import { useTranslation } from 'react-i18next'

import { LocaleLink } from '@/navigation/LocaleLink'
import { article as articleUi } from '@/shared/lib/articleStyles'

/** Compact CTA under the sticky TOC rail (desktop + mobile after index). */
export function ArticleRailCta() {
    const { t } = useTranslation()

    return (
        <div className={articleUi.railCta}>
            <img
                src='/food-cost/tipi-character-glasses.webp'
                alt=''
                width={104}
                height={104}
                className={articleUi.railCtaMascot}
                decoding='async'
            />
            <p className={articleUi.railCtaTitle}>
                {t('foodCost.hero.subtitle', '¿Sabes cuánto te cuestan tus platos?')}
            </p>
            <p className={articleUi.railCtaBody}>
                {t(
                    'article.railCta.body',
                    'Escandallos, costes y margen en un solo sitio. Sin hojas de cálculo eternas.',
                )}
            </p>
            <LocaleLink to='/#form' className={articleUi.railCtaButton}>
                {t('foodCost.header.cta', 'Probar ahora')}
            </LocaleLink>
        </div>
    )
}
